import { Component, Input, OnInit } from '@angular/core';
import { Currency } from '@freelancer/datastore/currencies';
import { ModalRef } from '@freelancer/ui';

@Component({
  template: `
    <!-- TODO: Port modal to webapp stack  -->
  `,
})
export class RequestMilestoneModalComponent implements OnInit {
  @Input() bidId: number;
  @Input() bidderId: number;
  @Input() projectId: number;
  @Input() employerUsername: string;
  @Input() currencyDetails: Currency;

  constructor(private modalRef: ModalRef<RequestMilestoneModalComponent>) {}

  ngOnInit() {
    // FIXME: port this modal to the webapp stack
    (<any>window).messagingWebappCompatModals.RequestMilestoneModal.initModal(
      {
        bidId: this.bidId,
        projectId: this.projectId,
        bidderId: this.bidderId,
        employerUsername: this.employerUsername,
        currencyDetails: this.currencyDetails,
      },
      () => undefined,
      true,
    );
  }

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/request-milestone-modal/request-milestone-modal.component.ts